import { render, staticRenderFns } from "./setClassDialog.vue?vue&type=template&id=42054cb9"
import script from "./setClassDialog.vue?vue&type=script&lang=js"
export * from "./setClassDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports